import "./styles.css";

/**
 * @function
 * @name Day 
 * @param {OBJECT} props 
 * @extends React
 */
export default function Day(props) {
    let { newDate, setDate, currentMonth, controllers, setHover,inputDate } = props;
    let { allowPast ,allowFuture,close} = controllers;

allowFuture = undefined? false: allowFuture;
    /**
     * @function
     * @memberof Day
     * @returns BOOLEAN - returns true if the day is in the currentMonth and is the selected day
     */
    function selected() {
        return newDate.isEqual(setDate) && (currentMonth.monthInt == newDate.monthInt) && inputDate !== "";
    }
    
    /**
     * @function
     * @memberof Day 
     * @returns BOOLEAN - returns true if the day is in past and not part of current month
     */
    function disabled() {
        return (!allowPast ? newDate.isPast() : false)||(!allowFuture ? newDate.isFuture() : false)|| (currentMonth.monthInt != newDate.monthInt);
    }

    /**     
     * @memberof Day 
     * @function    
     * @param {OBJECT} event the click event for the day 
     * @returns VOID
     */
    function onClick(event) {
        if (disabled() === false) {
            props.onChange(newDate)
           close();
        }
    }

    /**     
     * @memberof Day
     * @function     
     * @param {OBJECT} event mouse in event
     * @returns VOID  
     */
    function mouseIn(event) {
        if (disabled() === false) {
            setHover(newDate)
        }
    }

    /**    
     * @memberof Day
     * @function    
     * @param {OBJECT} event mouse in event
     * @returns VOID    
     */
    function mouseOut(event) {        
        setHover(setDate)       
    }
    return (
        <span className={(newDate.isToday() ? "current-day " : "") + (selected() ? "selected " : " ") + "week-day" + (disabled() ? " grey " : " ")} onMouseEnter={mouseIn} onMouseLeave={mouseOut} onClick={onClick}>
            <span data-point={"date_select_"+newDate.diff(setDate)} className={"day-number"}>{newDate.dayInt}</span>
        </span>
    )
}
